function initMembershipFloatingWidget() {
  const widget = document.querySelector('.membership-floating-widget');
  if (!widget) return;

  const closeButton = widget.querySelector('.membership-floating-widget__close');
  if (!closeButton) return;

  closeButton.addEventListener('click', () => {
    widget.classList.add('membership-floating-widget--hidden');
  });

  setTimeout(() => {
    if (widget) {
      widget.classList.remove('membership-floating-widget--hidden');
    }
  }, 7000);
}

initMembershipFloatingWidget();
